import { ChainId } from '@pulsex/chains'

export const DEFAULT_BLOCK_CONFLICT_TOLERANCE = 0

export const BLOCK_CONFLICT_TOLERANCE: { [key in ChainId]?: number } = {
  [ChainId.PULSECHAIN]: 3,
  [ChainId.PULSECHAIN_TESTNET]: 3,
}
